$(document).ready(function () {
 // shop by collection slider
  $(".newslist-sec .news-ul").slick({
		dots: false,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2500,		
		responsive: [
			{
				breakpoint: 1201,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 577,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					
				},
			}
		],
	});

});

